import { createThis2j2avj17cvnv2 as createThis } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_HttpTimeout3mcrbvfnvmyx2 as get_HttpTimeout } from '../../../../../ktor-ktor-client-core/io/ktor/client/plugins/HttpTimeout.mjs';
import { setReadTimeout12jih49pjfudm as setReadTimeout } from './KtorHttpEngine.js.mjs';
import { HttpClient3584jcajl7sef as HttpClient } from '../../../../../ktor-ktor-client-core/io/ktor/client/HttpClient.web.mjs';
import {
  HttpRequestBuilder15f2nnx9sjuv1 as HttpRequestBuilder,
  url2l6iw5ri21nxb as url,
} from '../../../../../ktor-ktor-client-core/io/ktor/client/request/HttpRequest.mjs';
import { Companion_getInstance29j9s2wnmk34z as Companion_getInstance } from '../../../../../ktor-ktor-http/io/ktor/http/HttpMethod.mjs';
import {
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { header3kx6g3yb4df1r as header } from '../../../../../ktor-ktor-client-core/io/ktor/client/request/utils.mjs';
import { Buffer3384y49aj0pxr as Buffer } from '../../../../../okio-parent-okio/okio/Buffer.mjs';
import { PrimitiveClasses_getInstance13wbaztpz3e2d as PrimitiveClasses_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/primitives.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from '../../../../../ktor-ktor-utils/io/ktor/util/reflect/Type.mjs';
import {
  OutgoingContent3t2ohmyam9o76 as OutgoingContent,
  NullBody_instance22vwyocs8eppk as NullBody_instance,
} from '../../../../../ktor-ktor-http/io/ktor/http/content/OutgoingContent.mjs';
import { HttpStatement3zxb33q8lku as HttpStatement } from '../../../../../ktor-ktor-client-core/io/ktor/client/statement/HttpStatement.mjs';
import { isByteArray4nnzfn1x4o3w as isByteArray } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  Builder1mo34du82b3c6 as Builder,
  HttpHeader1d7ldebjomr00 as HttpHeader,
} from '../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/http/Http.mjs';
import { flattenEntries2zw7fl55k6a0l as flattenEntries } from '../../../../../ktor-ktor-utils/io/ktor/util/StringValues.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { ApolloNetworkException3denf70pfh242 as ApolloNetworkException } from '../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/exception/Exceptions.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { HttpEngine345320iy1heif as HttpEngine } from '../../../../../apollo-kotlin-apollo-runtime/com/apollographql/apollo/network/http/HttpEngine.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var KtorHttpEngineClass;
function KtorHttpEngine() {
  if (KtorHttpEngineClass === VOID) {
    class $ {
      constructor(client) {
        return new.target.l6f(client);
      }
      static l6f(client) {
        var $this = createThis(this);
        $this.j6f_1 = client;
        $this.k6f_1 = false;
        return $this;
      }
      static r6f(timeoutMillis) {
        timeoutMillis = timeoutMillis === VOID ? 60000n : timeoutMillis;
        return this.s6f(timeoutMillis, timeoutMillis);
      }
      static s6f(connectTimeoutMillis, readTimeoutMillis) {
        return this.l6f(HttpClient(($this$HttpClient) => {
          $this$HttpClient.g5k_1 = false;
          var tmp = get_HttpTimeout();
          $this$HttpClient.g5l(tmp, ($this$install) => {
            $this$install.d5v(connectTimeoutMillis);
            setReadTimeout($this$install, readTimeoutMillis);
            return Unit_instance;
          });
          return Unit_instance;
        }));
      }
      *f68(request, $completion) {
        try {
          var tmp0 = this.j6f_1;
          // Inline function 'io.ktor.client.request.request' call
          var urlString = request.a4c_1;
          // Inline function 'io.ktor.client.request.request' call
          // Inline function 'kotlin.apply' call
          var this_0 = new (HttpRequestBuilder())();
          url(this_0, urlString);
          var tmp = this_0;
          var tmp_0;
          switch (request.z4b_1.w1_1) {
            case 0:
              tmp_0 = Companion_getInstance().v54_1;
              break;
            case 1:
              tmp_0 = Companion_getInstance().w54_1;
              break;
            default:
              noWhenBranchMatchedException();
              break;
          }
          tmp.y5k_1 = tmp_0;
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s = request.b4c_1.p1();
          while (_iterator__ex2g4s.q1()) {
            var element = _iterator__ex2g4s.r1();
            header(this_0, element.l4b_1, element.m4b_1);
          }
          var tmp1_safe_receiver = request.c4c_1;
          if (tmp1_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            header(this_0, 'Content-Type', tmp1_safe_receiver.g4a());
            var buffer = new (Buffer())();
            tmp1_safe_receiver.i4a(buffer);
            // Inline function 'io.ktor.client.request.setBody' call
            var body = buffer.y3y();
            if (body == null) {
              this_0.a5l_1 = NullBody_instance;
              // Inline function 'io.ktor.util.reflect.typeInfo' call
              var tmp_1 = PrimitiveClasses_getInstance().gg();
              var tmp_2 = !(null == null) ? typeof null === 'string' : false;
              // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
              var tmp_3;
              try {
                tmp_3 = createKType(PrimitiveClasses_getInstance().gg(), arrayOf([]), false);
              } catch ($p) {
                var tmp_4;
                if ($p instanceof Error) {
                  var _unused_var__etf5q3 = $p;
                  tmp_4 = null;
                } else {
                  throw $p;
                }
                tmp_3 = tmp_4;
              }
              var tmp$ret$11 = tmp_3;
              var tmp$ret$10 = new (TypeInfo())(tmp_1, tmp_2, tmp$ret$11);
              this_0.q5o(tmp$ret$10);
            } else {
              if (body instanceof OutgoingContent()) {
                this_0.a5l_1 = body;
                this_0.q5o(null);
              } else {
                this_0.a5l_1 = body;
                // Inline function 'io.ktor.util.reflect.typeInfo' call
                var tmp_5 = PrimitiveClasses_getInstance().gg();
                var tmp_6 = !(null == null) ? typeof null === 'string' : false;
                // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
                var tmp_7;
                try {
                  tmp_7 = createKType(PrimitiveClasses_getInstance().gg(), arrayOf([]), false);
                } catch ($p_0) {
                  var tmp_8;
                  if ($p_0 instanceof Error) {
                    var _unused_var__etf5q3_0 = $p_0;
                    tmp_8 = null;
                  } else {
                    throw $p_0;
                  }
                  tmp_7 = tmp_8;
                }
                var tmp$ret$13 = tmp_7;
                var tmp$ret$12 = new (TypeInfo())(tmp_5, tmp_6, tmp$ret$13);
                this_0.q5o(tmp$ret$12);
              }
            }
          }
          // Inline function 'io.ktor.client.request.request' call
          var response = yield* (new (HttpStatement())(this_0, tmp0)).j5z($completion);
          // Inline function 'io.ktor.client.call.body' call
          var tmp_9 = response.v5l();
          // Inline function 'io.ktor.util.reflect.typeInfo' call
          var tmp_10 = PrimitiveClasses_getInstance().kg();
          var tmp_11 = !(null == null) ? isByteArray(null) : false;
          // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
          var tmp_12;
          try {
            tmp_12 = createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false);
          } catch ($p_1) {
            var tmp_13;
            if ($p_1 instanceof Error) {
              var _unused_var__etf5q3_1 = $p_1;
              tmp_13 = null;
            } else {
              throw $p_1;
            }
            tmp_12 = tmp_13;
          }
          var tmp$ret$17 = tmp_12;
          var tmp$ret$16 = new (TypeInfo())(tmp_10, tmp_11, tmp$ret$17);
          var tmp_14 = yield* tmp_9.s5l(tmp$ret$16, $completion);
          var responseByteArray = (!(tmp_14 == null) ? isByteArray(tmp_14) : false) ? tmp_14 : THROW_CCE();
          var responseBufferedSource = (new (Buffer())()).l3z(responseByteArray);
          var tmp_15 = (new (Builder())(response.e5m().t57_1)).s4b(responseBufferedSource);
          // Inline function 'kotlin.collections.map' call
          var this_1 = flattenEntries(response.u54());
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList().i2(collectionSizeOrDefault(this_1, 10));
          var _iterator__ex2g4s_0 = this_1.p1();
          while (_iterator__ex2g4s_0.q1()) {
            var item = _iterator__ex2g4s_0.r1();
            var tmp$ret$20 = new (HttpHeader())(item.bf_1, item.cf_1);
            destination.j2(tmp$ret$20);
          }
          return tmp_15.d4b(destination).v39();
        } catch ($p_2) {
          if ($p_2 instanceof CancellationException()) {
            var e = $p_2;
            throw e;
          } else {
            if ($p_2 instanceof Error) {
              var t = $p_2;
              throw ApolloNetworkException().r49(t.message, t);
            } else {
              throw $p_2;
            }
          }
        }
      }
      m6() {
        if (!this.k6f_1) {
          this.j6f_1.m6();
          this.k6f_1 = true;
        }
      }
    }
    initMetadataForClass($, 'KtorHttpEngine', $.r6f, VOID, [HttpEngine()], [1]);
    KtorHttpEngineClass = $;
  }
  return KtorHttpEngineClass;
}
//region block: exports
export {
  KtorHttpEngine as KtorHttpEngine1d787w9ug90jw,
};
//endregion

//# sourceMappingURL=KtorHttpEngine.mjs.map
